import { render, staticRenderFns } from "./ScreenActions.vue?vue&type=template&id=35beb286"
import script from "./ScreenActions.vue?vue&type=script&lang=js"
export * from "./ScreenActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports